(() => {
  const ROOT_SELECTOR = '[data-google-reviews-gallery]';

  class GoogleReviewsGallery {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-review-grid]');
      this.button = root.querySelector('[data-load-reviews]');
      this.status = root.querySelector('[data-review-status]');
      this.source = root.dataset.reviewSource;
      this.batchSize = Math.max(1, Number(root.dataset.batchSize || 6));
      this.labels = {
        loading: root.dataset.loadingLabel || 'Bewertungen werden geladen …',
        more: root.dataset.moreLabel || 'Weitere Bewertungen ansehen',
        retry: root.dataset.retryLabel || 'Erneut versuchen',
        loaded: root.dataset.loadedLabel || 'weitere Bewertungen wurden angezeigt.',
        error: root.dataset.errorLabel || 'Die weiteren Bewertungen konnten nicht geladen werden.',
        imageAlt: root.dataset.imageAlt || 'Google-Bewertung eines VitaRenew-Kunden',
      };
      this.images = null;
      this.cursor = 0;
    }

    connect() {
      if (!this.grid || !this.button || !this.source) return;
      this.button.addEventListener('click', () => this.loadNextBatch());
    }

    async loadImages() {
      if (this.images) return this.images;
      const response = await fetch(this.source, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Bewertungen konnten nicht geladen werden (${response.status}).`);
      const payload = await response.json();
      this.images = Array.isArray(payload.images) ? payload.images.filter((url) => typeof url === 'string' && url) : [];
      return this.images;
    }

    appendImage(url) {
      const figure = document.createElement('figure');
      figure.className = 'google-reviews-gallery__item';
      const image = document.createElement('img');
      image.src = url;
      image.alt = this.labels.imageAlt;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 640;
      image.height = 360;
      figure.appendChild(image);
      this.grid.appendChild(figure);
    }

    async loadNextBatch() {
      if (this.button.getAttribute('aria-busy') === 'true') return;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.labels.loading;

      try {
        const images = await this.loadImages();
        const next = images.slice(this.cursor, this.cursor + this.batchSize);
        next.forEach((url) => this.appendImage(url));
        this.cursor += next.length;

        if (this.status) this.status.textContent = `${next.length} ${this.labels.loaded}`;
        if (this.cursor >= images.length) {
          this.button.remove();
        } else {
          this.button.textContent = this.labels.more;
          this.button.removeAttribute('aria-busy');
        }
      } catch (error) {
        console.error(error);
        this.button.textContent = this.labels.retry;
        this.button.removeAttribute('aria-busy');
        if (this.status) this.status.textContent = this.labels.error;
      }
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.googleReviewsReady === 'true') return;
      root.dataset.googleReviewsReady = 'true';
      new GoogleReviewsGallery(root).connect();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
